import { createRecordType, defineMigrations } from "@supersig/store";
import { T } from "@supersig/validate";
import { nanoid } from "nanoid";
import { idValidator } from "../misc/id-validator";
export const PaywallLanguageValidator = T.model("paywall_language", T.object({
    id: idValidator("paywall_language"),
    typeName: T.literal("paywall_language")
}));
export const localeToHumanReadable = (locale)=>{
    const languageNames = new Intl.DisplayNames([
        "en"
    ], {
        type: "language"
    });
    const countryNames = new Intl.DisplayNames([
        "en"
    ], {
        type: "region"
    });
    let language = undefined;
    let country = undefined;
    if (locale.includes("_")) {
        const parts = locale.split("_");
        language = parts[0];
        country = parts[1];
    } else {
        language = locale;
    }
    // turn the country code into a country name
    try {
        country = country ? countryNames.of(country) : country;
    } catch (e) {}
    try {
        language = language ? languageNames.of(language) : language;
    } catch (e) {}
    return `${language}${country ? ` (${country})` : ""}`;
};
export const castPaywallLanguage = (paywallLanguage)=>{
    const languageNames = new Intl.DisplayNames([
        "en"
    ], {
        type: "language"
    });
    return {
        toLocale () {
            return paywallLanguage.id.replace(/^paywall_language:/, "");
        },
        toHumanReadable () {
            const rawLocale = paywallLanguage.id.replace(/^paywall_language:/, "");
            return localeToHumanReadable(rawLocale);
        },
        toEmoji () {
            return String.fromCodePoint(...[
                ...paywallLanguage.id.replace(/^paywall_language:/, "").toUpperCase()
            ].map((x)=>0x1f1a5 + x.charCodeAt(0)));
        }
    };
};
export const SWPaywallLanguageRecordType = createRecordType("paywall_language", {
    migrations: defineMigrations({}),
    validator: PaywallLanguageValidator,
    scope: "document"
}).withDefaultProperties(()=>({}));
export function isPaywallLanguage(record) {
    if (!record) return false;
    return record.typeName === "paywall_language";
}
export function isPaywallLanguageId(id) {
    if (!id) return false;
    return id.startsWith("paywall_language:");
}
/** @public */ export function createPaywallLanguageId(id) {
    return `paywall_language:${id ?? nanoid()}`;
}
